// extracted by mini-css-extract-plugin
export default {"updateCheckPage":"UpdateCheckPage_updateCheckPage__+j4kk"};